/* eslint-disable */
import { FuseNavigationItem } from '@fuse/components/navigation';


export const defaultNavigation: FuseNavigationItem[] = [

	{
		id: 'divider1',
		type: 'divider',
	},
	// {
	// 	id: 'tasks',
	// 	title: 'Tasks',
	// 	type: 'basic',
	// 	icon: 'heroicons_outline:check-circle',
	// 	link: '/apps/tasks',
	// 	disabled: true
	// },
	{
		id: 'sites',
		title: 'Sites',
		type: 'basic',
		icon: 'heroicons_outline:location-marker',
		auth: ['/exploration-users'],
		link: '/apps/sites',
	},
	{
		id: 'dashboards',
		title: 'Dashboards',
		subtitle: 'Summary of essential insights and data',
		auth: ['/exploration-users'],
		type: 'group',
		children: [
			{
				id: 'dashboards.finance',
				title: 'Finance',
				type: 'basic',
				icon: 'heroicons_outline:cash',
				link: '/dashboards/analytics',
				disabled: false,
				auth: ['/menu/finance'],

			},
		]
	}, {
		id: 'apps',
		title: 'Applications',
		subtitle: 'Manage all your applications',
		auth: ['/exploration-users'],
		type: 'group',
		children: [
			{
				id: 'apps.drilling',
				title: 'Drilling',
				//subtitle: 'Drilling operations and data management',
				type: 'collapsable',
				icon: 'heroicons_outline:inbox-in',
				auth: ['/menu/drilling'],
				children: [
					{
						id: 'apps.drilling.drillholes',
						title: 'Drillholes',
						type: 'basic',
						icon: 'heroicons_outline:clipboard-check',
						link: '/apps/hole',
					}
				]
			},
			{
				id: 'apps.laboratory',
				title: 'Laboratory',
				//subtitle: 'Laboratory management and results',
				type: 'collapsable',
				icon: 'heroicons_outline:beaker',
				auth: ['/menu/laboratory'],
				children: [
					{
						id: 'apps.laboratory.despatch',
						title: 'Despatch',
						type: 'basic',
						icon: 'heroicons_outline:truck',
						link: '/apps/laboratory/despatches',
						disabled: false,
					},
					{
						id: 'apps.laboratory.samples',
						title: 'Samples',
						type: 'basic',
						link: '/apps/laboratory/samples',
						icon: 'heroicons_outline:beaker',
						disabled: false,
					},
					{
						id: 'apps.laboratory.certificates',
						title: 'Laboratory jobs',
						type: 'basic',
						link: '/apps/laboratory/laboratory-jobs',
						icon: 'heroicons_outline:document-text',
						auth: ['/global/management'],
						disabled: false,
					},
					{
						id: 'apps.laboratory.qaqc',
						title: 'QAQC',
						type: 'collapsable',
						icon: 'heroicons_outline:badge-check',
						auth: ['/roles/qaqc_analyst'],
						children: [
							{
								id: 'apps.laboratory.qaqc.analytics',
								title: 'Analytics',
								type: 'basic',
								link: '/apps/qaqc/analytics-dashboard',
								icon: 'heroicons_outline:beaker',
							},
							{
								id: 'apps.laboratory.qaqc.reports-management',
								title: 'Reports Management',
								type: 'basic',
								link: '/apps/qaqc/reports-management',
								icon: 'heroicons_outline:clipboard-check',
							},
							{
								id: 'apps.laboratory.qaqc.assay-approval',
								title: 'Assay Approval',
								type: 'basic',
								link: '/apps/qaqc/assay-approval',
								icon: 'heroicons_outline:check-circle',
							},
							{
								id: 'apps.laboratory.qaqc.reanalysis-tracking',
								title: 'Reanalysis Tracking',
								type: 'basic',
								link: '/apps/qaqc/reanalysis-tracking',
								icon: 'heroicons_outline:refresh',
							},
						]
					},
				]
			},
			{
				id: 'management-hub',
				title: 'Management Hub',
				type: 'basic',
				//icon for control center
				icon: 'heroicons_outline:cog',
				link: '/apps/management-hub',
				auth: ['/menu/management'],
			}

		]
	}
];

export const compactNavigation: FuseNavigationItem[] = [
	{
		id: 'dashboards',
		title: 'Dashboards',
		tooltip: 'Dashboards',
		type: 'aside',
		icon: 'heroicons_outline:home',
		children: [] // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
	},
	{
		id: 'apps',
		title: 'Apps',
		tooltip: 'Apps',
		type: 'aside',
		icon: 'heroicons_outline:qrcode',
		children: [] // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
	},
	{
		id: 'pages',
		title: 'Pages',
		tooltip: 'Pages',
		type: 'aside',
		icon: 'heroicons_outline:document-duplicate',
		children: [] // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
	},
	{
		id: 'user-interface',
		title: 'UI',
		tooltip: 'UI',
		type: 'aside',
		icon: 'heroicons_outline:collection',
		children: [] // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
	},
	{
		id: 'navigation-features',
		title: 'Navigation',
		tooltip: 'Navigation',
		type: 'aside',
		icon: 'heroicons_outline:menu',
		children: [] // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
	}
];
export const futuristicNavigation: FuseNavigationItem[] = [
	{
		id: 'dashboards',
		title: 'DASHBOARDS',
		type: 'group',
		children: [] // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
	},
	{
		id: 'apps',
		title: 'APPS',
		type: 'group',
		children: [] // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
	},
	{
		id: 'others',
		title: 'OTHERS',
		type: 'group'
	},
	{
		id: 'pages',
		title: 'Pages',
		type: 'aside',
		icon: 'heroicons_outline:document-duplicate',
		children: [] // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
	},
	{
		id: 'user-interface',
		title: 'User Interface',
		type: 'aside',
		icon: 'heroicons_outline:collection',
		children: [] // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
	},
	{
		id: 'navigation-features',
		title: 'Navigation Features',
		type: 'aside',
		icon: 'heroicons_outline:menu',
		children: [] // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
	}
];
export const horizontalNavigation: FuseNavigationItem[] = [
	{
		id: 'dashboards',
		title: 'Dashboards',
		type: 'group',
		icon: 'heroicons_outline:home',
		children: [] // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
	},
	{
		id: 'apps',
		title: 'Apps',
		type: 'group',
		icon: 'heroicons_outline:qrcode',
		children: [] // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
	},
	{
		id: 'pages',
		title: 'Pages',
		type: 'group',
		icon: 'heroicons_outline:document-duplicate',
		children: [] // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
	},
	{
		id: 'user-interface',
		title: 'UI',
		type: 'group',
		icon: 'heroicons_outline:collection',
		children: [] // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
	},
	{
		id: 'navigation-features',
		title: 'Misc',
		type: 'group',
		icon: 'heroicons_outline:menu',
		children: [] // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
	}
];
